import React from 'react'
import './section.css'

function SectionHeader({ children, image, style, id }) {
  return (
    <h2
      className="section-header"
      style={{
        ...style,
      }}
    >
      <div style={{ marginRight: '0.25em' }}>{image}</div>
      {children}
    </h2>
  )
}

function SectionBody({ children }) {
  return <div>{children}</div>
}

export default function Section({
  id,
  header,
  headerStyle,
  headerImage,
  children,
}) {
  return (
    <section className="section" id={id}>
      <SectionHeader style={headerStyle} image={headerImage}>
        {header}
      </SectionHeader>
      <SectionBody>{children}</SectionBody>
    </section>
  )
}
